import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import c_earth from '../assets/EveyaBanner1.png';
import c2 from '../assets/EveyaBanner2.png';
import c1 from '../assets/EveyaBanner3.png';
const Carousel = () => {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  
  const slides = [
    {
 url: c2,
      title: "Move With Confidence",
      subtitle: "Ultra-thin protection that stays in place, no matter how you move.",
    },
    {
      url: c1,
      title: "Subscription Made Simple",
      subtitle: "Never run out again. Get your customized pack delivered monthly.",
    },
    {
      url: c_earth,
      title: "Move With Confidence",
      subtitle: "Ultra-thin protection that stays in place, no matter how you move.",
    }
  ];

  const handleExplorePackages = () => {
    navigate("/packages");
  };

  const next = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prev = () => setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  // Optional: Auto-play functionality
  useEffect(() => {
    const slideInterval = setInterval(next, 5000);
    return () => clearInterval(slideInterval);
  }, []);

  return (
    <div className="relative w-full h-[35rem] md:h-[45rem] overflow-hidden rounded-b-[3rem] md:rounded-b-[5rem] shadow-2xl">
      {slides.map((slide, idx) => {
        const isCurrent = idx === current;

        return (
          <div
            key={idx}
            className={`absolute inset-0 transition-all duration-1000 ease-in-out transform ${
              isCurrent ? "opacity-100 scale-100" : "opacity-0 scale-110 pointer-events-none"
            }`}
          >
            {/* Background Image */}
            <img
              src={slide.url}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            
            {/* Soft Pinkish Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-pink-900/60 via-pink-800/20 to-transparent"></div>

            {/* Content Overlay */}
            <div className="absolute inset-0 flex items-center justify-start px-10 md:px-24">
              <div className={`max-w-2xl text-left transition-all duration-700 delay-300 ${isCurrent ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
                <h1 className="text-4xl md:text-7xl font-extrabold text-white mb-6 drop-shadow-md leading-tight">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl text-pink-50 mb-10 drop-shadow max-w-lg">
                  {slide.subtitle}
                </p>
                <button
                  onClick={handleExplorePackages}
                  className="bg-white text-pink-600 hover:bg-pink-50 font-bold text-lg px-10 py-4 rounded-full shadow-xl transition-all transform hover:scale-105 flex items-center gap-3"
                >
                  Choose Your Plan <ArrowRight />
                </button>
              </div>
            </div>
          </div>
        );
      })}

      {/* Navigation Controls */}
      <button
        onClick={prev}
        className="absolute left-6 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white text-white hover:text-pink-600 p-3 rounded-full transition-all duration-300 z-10 backdrop-blur-sm"
      >
        <ChevronLeft size={28} />
      </button>

      <button
        onClick={next}
        className="absolute right-6 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white text-white hover:text-pink-600 p-3 rounded-full transition-all duration-300 z-10 backdrop-blur-sm"
      >
        <ChevronRight size={28} />
      </button>

      {/* Indicators (Dots) */}
      <div className="absolute bottom-10 left-10 md:left-24 flex gap-3 z-10">
        {slides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`h-2 rounded-full transition-all duration-500
              ${idx === current ? "bg-white w-12" : "bg-white/40 w-3 hover:bg-white/60"}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;